module.exports = __webpack_public_path__ + "static/media/imge-5.370c5ff7.jpg";